import styles from './Cell.module.scss';

export interface CellProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLDivElement>,
    HTMLDivElement
  > {
  title: string;
  subtitle?: string;
  prefixIcon?: React.ReactNode;
  suffixIcon?: React.ReactNode;
  separator?: React.ReactNode;
  testId: string;
}

export const Cell = ({
  title,
  subtitle,
  prefixIcon,
  suffixIcon,
  separator,
  testId,
  ...props
}: CellProps) => {
  const testIdPrefix = `${testId}-cell`;

  const getElementTestId = (suffix: string) => {
    return `${testIdPrefix}-${suffix}`;
  };

  return (
    <div
      {...props}
      className={styles.cellContainer}
      data-test-id={getElementTestId('container')}
    >
      <div className={styles.cell} data-test-id={getElementTestId('content')}>
        {prefixIcon && (
          <div
            className={styles.prefixIcon}
            data-test-id={getElementTestId('prefix-icon')}
          >
            {prefixIcon}
          </div>
        )}
        <div className={styles.content}>
          <div
            className={styles.title}
            data-test-id={getElementTestId('title')}
          >
            {title}
          </div>
          {subtitle && (
            <div
              className={styles.subtitle}
              data-test-id={getElementTestId('subtitle')}
            >
              {subtitle}
            </div>
          )}
        </div>
        {suffixIcon && (
          <div
            className={styles.suffixIcon}
            data-test-id={getElementTestId('suffix-icon')}
          >
            {suffixIcon}
          </div>
        )}
      </div>
      {separator && (
        <div
          className={styles.separator}
          data-test-id={getElementTestId('separator')}
        >
          {separator}
        </div>
      )}
    </div>
  );
};
